(function () {
    'use strict';

    angular
        .module('rhipeSupportserviceportal',
        ['ngAnimate'
            , 'ngCookies'
            , 'ngTouch'
            , 'ngSanitize'
            , 'ngMessages'
            , 'ngAria'
            , 'ngResource'
            , 'ui.router'
            , 'ngMaterial'
            , 'toastr'
            , 'SignalR'
            , 'angularMoment'
            , 'ngOrderObjectBy'
            , 'ngLodash'
            , 'mdCollectionPagination'
            , 'angular-jwt'
            , 'ngMdIcons'
            , 'md.data.table'
            , 'bsLoadingOverlay'
            , 'material.components.expansionPanels'
        ]);

})();

(function() {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .controller('scheduledJobDetailsController', scheduledJobDetailsController);

    /** @ngInject */
    function scheduledJobDetailsController(
        $mdDialog,
        jobName,
        jobFullName,
        moment,
        scheduledJobsService,
        notificationsService,
        $timeout,
        $scope) {
        var vm = this,
            loadJobDetailsTimeout;
        vm.jobName = jobName;
        loadJobHistory();

        $scope.$on(
            '$destroy',
            function() {
                if (loadJobDetailsTimeout) {
                    $timeout.cancel(loadJobDetailsTimeout);
                }
            });

        function loadJobHistory() {
            vm.isLoadingJobHistory = true;
            scheduledJobsService.getJobHistory(jobFullName).then(
                    function(result) {
                        vm.jobHistory = result.data.map(
                            function(record) {
                                var diff =
                                    moment(record.CompletedAt)
                                        .diff(moment(record.StartedAt), 'milliseconds');
                                record.Duration =
                                    moment(diff)
                                    .utc()
                                    .format('H[h] m[min] s[sec]').replace('0h 0min ', '').replace('0h ', '');

                                if (record.Duration === '0sec') {
                                    record.Duration = diff + 'ms';
                                }

                                return record;
                            });
                    },
                    function() {
                        notificationsService.failure('An unexpected error occurred', 'Unable to load job history');
                    })
                .finally(
                    function() {
                        vm.isLoadingJobHistory = false;
                        loadJobDetailsTimeout = $timeout(loadJobHistory, 5000);
                    });
        }

        vm.close = function() {
            $mdDialog.cancel();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .controller('backgroundJobDetailsController', backgroundJobDetailsController);

    /** @ngInject */
    function backgroundJobDetailsController(
        $mdDialog,
        jobName,
        jobFullName,
        moment,
        backgroundJobsService,
        notificationsService,
        $timeout,
        $scope) {
        var vm = this,
            loadJobDetailsTimeout;

        vm.jobName = jobName;
        vm.jobHistory = [];
        loadJobHistory();

        $scope.$on(
            '$destroy',
            function() {
                if (loadJobDetailsTimeout) {
                    $timeout.cancel(loadJobDetailsTimeout);
                }
            });

        function loadJobHistory() {
            vm.isLoadingJobHistory = true;
            backgroundJobsService.getJobHistory(jobFullName).then(
                    function(result) {
                        var updatedRecords = result.data.map(
                            function(record) {
                                var diff =
                                    moment(record.CompletedAt)
                                        .diff(moment(record.StartedAt), 'milliseconds');
                                record.Duration =
                                    moment(diff)
                                    .utc()
                                    .format('H[h] m[min] s[sec]').replace('0h 0min ', '').replace('0h ', '');

                                if (record.Duration === '0sec') {
                                    record.Duration = diff + 'ms';
                                }

                                return record;
                            });

                        updateRecords(updatedRecords);
                    },
                    function() {
                        notificationsService.failure(
                            'An unexpected error occurred',
                            'Unable to load background job history');
                    })
                .finally(
                    function() {
                        vm.isLoadingJobHistory = false;
                        loadJobDetailsTimeout = $timeout(loadJobHistory, 5000);
                    });
        }

        function updateRecords(updatedRecords) {
            vm.jobHistory.forEach(
                function(existingRecord, index) {
                    var updatedRecord = updatedRecords.find(
                        function(u) {
                            return u.JobId === existingRecord.JobId;
                        });

                    if (angular.isUndefined(updatedRecord)) {
                        vm.jobHistory.splice(index, 1);
                    }

                    angular.extend(existingRecord, updatedRecord);
                }
            );

            updatedRecords.forEach(
                function(updatedRecord) {
                    var existingRecord = vm.jobHistory.find(
                        function(j) {
                            return j.JobId === updatedRecord.JobId;
                        });

                    if (angular.isUndefined(existingRecord)) {
                        vm.jobHistory.push(updatedRecord);
                    }
                });
        }

        vm.close = function() {
            $mdDialog.cancel();
        };

        vm.format = function(job) {
            return angular.toJson(angular.parse(job), null, 4);
        };
    }
})();

(function() {
  'use strict';

  angular
    .module('rhipeSupportserviceportal')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
      $stateProvider
          .state("sessionExpired", {
              url: "/session/expired",
              template: "<session-expired></session-expired>",
              authorization: []
          });
  }

})();

(function () {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .directive('sessionExpired', sessionExpired);

    /** @ngInject */
    function sessionExpired() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/session/sessionExpired.html',
            scope: {},
            controller: SessionExpiredController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function SessionExpiredController() {
       
        }
    }

})();

(function() {
        'use strict';

        /** @ngInject */
        function scheduledJobsService(configuration, $http) {
            return {
                enableJob: enableJob,
                listJobs: listJobs,
                getJobHistory: getJobHistory,
                runJob: runJob
            };

            function listJobs() {
              var url = configuration.apiUrl + '/admin/scheduled-jobs';
                return $http.get(url);
            }

            function getJobHistory(jobName) {
              var url = configuration.apiUrl + '/admin/scheduled-jobs/' + jobName + '/history';
                return $http.get(url);
            }

            function runJob(jobName) {
              var url = configuration.apiUrl + '/admin/scheduled-jobs/run';
                return $http.post(url, { JobName: jobName});
            }

            function enableJob(jobName) {
              var url = configuration.apiUrl + '/admin/scheduled-jobs/enable';
                return $http.post(url, { JobName: jobName});
            }
        }

        angular
            .module('rhipeSupportserviceportal')
            .factory('scheduledJobsService', scheduledJobsService);
    } 
)();

(function() {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, adRoles) {
        $stateProvider
            .state('scheduledJobs', {
                url: '/scheduled-jobs',
                template: '<scheduled-jobs></scheduled-jobs>',
                navItem: 'scheduledJobs',
                authorization: [adRoles.Admin]
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .directive('scheduledJobs', scheduledJobs);

    /** @ngInject */
    function scheduledJobs() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/scheduledJobs/scheduledJobs.html',
            scope: {},
            controller: scheduledJobsController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function scheduledJobsController(
            scheduledJobsService,
            notificationsService,
            $mdDialog,
            $document) {
            var vm = this;
            vm.jobs = [];

            vm.isLoading = false;
            vm.lastRefreshed = null;
            vm.refresh = loadScheduledJobs;

            loadScheduledJobs();

            function loadScheduledJobs() {
                if (vm.isLoading) {
                    return;
                }

                vm.isLoading = true;
                scheduledJobsService.listJobs().then(
                        function(result) {
                            updateJobs(result.data);
                            vm.lastRefreshed = new Date();
                        },
                        function() {
                            notificationsService.failure(
                                'An unexpected error occurred',
                                'Unable to load scheduled jobs');
                        })
                    .finally(
                        function() {
                            vm.isLoading = false;
                        });
            }

            function updateJobs(updatedJobs) {
                vm.jobs.forEach(
                    function(existingJob, index) {
                        var updatedJob = updatedJobs.find(
                            function(u) {
                                return u.Name === existingJob.Name;
                            });

                        if (angular.isUndefined(updatedJob)) {
                            vm.jobs.splice(index, 1);
                        }

                        angular.extend(existingJob, updatedJob);
                    }
                );

                updatedJobs.forEach(
                    function(updatedJob) {
                        var existingJob = vm.jobs.find(
                            function(j) {
                                return j.Name === updatedJob.Name;
                            });

                        if (angular.isUndefined(existingJob)) {
                            vm.jobs.push(updatedJob);
                        }
                    });
            }

            vm.showJobDetails = function(ev, job) {
                $mdDialog.show(
                    {
                        controller: 'scheduledJobDetailsController',
                        controllerAs: 'vm',
                        templateUrl: 'app/components/scheduledJobs/jobDetails/jobDetails.html',
                        parent: angular.element($document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            jobName: job.DisplayName,
                            jobFullName: job.FullName
                        }
                    });
            };

            vm.runJob = function(job) {
                vm.triggeringJob = true;
                scheduledJobsService.runJob(job.Name).then(
                        function() {
                            notificationsService.success('Job triggered', 'Success');
                        },
                        function() {
                            notificationsService.failure('An unexpected error occurred', 'Unable to run job');
                        })
                    .finally(
                        function() {
                            vm.triggeringJob = false;
                        });
            };

            vm.enableAndRunJob = function(job) {
                vm.triggeringJob = true;
                scheduledJobsService.enableJob(job.Name)
                    .then(function () {
                        job.IsDisabled = false;
                        vm.runJob(job);
                    })
                    .catch(function () {
                        notificationsService.failure('An unexpected error occurred', 'Unable to enable job');
                        vm.triggeringJob = false;
                    });
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .directive('selectedNavItem', selectedNavItem);

    /** @ngInject */
    function selectedNavItem() {
        return {
            restrict: 'A',
            replace: true,
            link: function ($scope, element, attributes, Nav) {
                var navItem = attributes.navItem;
                if (!navItem) return;

                Nav.current = navItem;
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .directive('navbar', navbar);

    /** @ngInject */
    function navbar() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            scope: {},
            controller: NavbarController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function NavbarController(portalVersion, adRoles, Nav, $scope, authContextService) {
            var vm = this;
            vm.Nav = Nav;
            $scope.$watch('vm.Nav', function () {
                vm.currentNavItem = Nav.current;
            }, true);
            vm.currentNavItem = Nav.current;
            vm.version = portalVersion;
            vm.adRoles = adRoles;
            vm.logOut = function() {
              authContextService.logOut();
            }
        }
    }

})();

(function() {
    "use strict";

    angular
        .module("rhipeSupportserviceportal")
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, adRoles) {
        $stateProvider
            .state("minions", {
                url: "/minions",
                template: "<minions></minions>",
                navItem: 'minions',
                authorization: [adRoles.Admin]
            });
    }

})();
(function () {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .service('minionRepository', minionRepository);

    /** @ngInject */
    function minionRepository($rootScope, minionsHubEvents, minionRepositoryEvents, lodash) {
        var repository = this;
        repository.machines = {};

        this.init = function () {

            var minionsHubEventsStateChanged = $rootScope.$on(minionsHubEvents.stateChanged,
                function (event, minions) {
                    repository.machines = lodash.groupBy(minions, 'MachineName');
                    $rootScope.$broadcast(minionRepositoryEvents.stateChanged, repository.machines);
                });

            $rootScope.$on('$destroy', minionsHubEventsStateChanged);
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('rhipeSupportserviceportal')
      .factory('minionRepositoryEvents', minionsRepositoryEvents);

  /** @ngInject */
  function minionsRepositoryEvents() {
    var events = {
      stateChanged: 'minionRepository:stateChanged'
    };

    return events;
  }
})();
(function () {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .factory('minionsHub', minionsHub);

    /** @ngInject */
    function minionsHub($, $rootScope, configuration, Hub, hubLogger, minionsHubEvents) {
        var hub,
            hubName = 'MinionHub',
            isRunning = false;

        var start = function () {
            isRunning = true;

            if (hub) {
                hubLogger.logAction(hubName, "start connect");
                hub.connect();
            } else {
                hubLogger.logAction(hubName, "start instantiate");
                hub = new Hub(hubName, {
                    listeners: {
                        'updateState': function (state) {
                            $rootScope.$broadcast(minionsHubEvents.stateChanged, state);
                        }
                    },
                    rootPath: configuration.signalrUri,
                    transport: ['webSockets'],
                    useSharedConnection: false,
                    methods: ['LoadData'],
                    errorHandler: function (error) {
                        hubLogger.logFailure(hubName, error);
                    },
                    stateChanged: function (state) {
                        hubLogger.logStateChanged(hubName, state);

                        if (state.newState === $.signalR.connectionState.connected) {
                            hub.LoadData();
                        } else if (isRunning && state.newState === $.signalR.connectionState.disconnected) {
                            start();
                        }
                    }
                });
            }
        };

        var stop = function() {
            hubLogger.logAction(hubName, "stop");
            isRunning = false;

            if (hub) {
                hub.disconnect();
            }
        };

        return {
            start: start,
            stop: stop
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .factory('minionsHubEvents', minionsHubEvents);

    /** @ngInject */
    function minionsHubEvents() {
        var events = {
            stateChanged: 'minions:stateChanged',
            connecting: 'minions:connecting',
            connected: 'minions:connected',
            reconnecting: 'minions:reconnecting',
            disconnected: 'minions:disconnected'
        };

        return events;
    }
})();
(function () {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .directive('minions', minions);

    /** @ngInject */
    function minions() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/minions/minions.html',
            scope: {},
            controller: minionsController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function minionsController($scope, authContextService, lodash, minionRepository, minionRepositoryEvents, minionsHub, minionService, moment, notificationsService) {
            var vm = this;
            vm.machines = minionRepository.machines;

            var stateChangedDeregistrationCallback = $scope.$on(minionRepositoryEvents.stateChanged,
                function (event, machines) {
                    vm.machines = machines;
                    $scope.$apply();
                });
            $scope.$on('$destroy', function () {
                stateChangedDeregistrationCallback();
                minionsHub.stop();
            });

            authContextService.checkAuthenticated()
                .then(function (isAuthenticated) {
                    if (isAuthenticated) {
                        minionsHub.start();
                    }
                });

            vm.getTheme = function (minion) {
                var minutes = moment().diff(minion.Timestamp, 'minutes');
                if (minutes > 15)
                    return "md-warn md-hue-2";
                if (minutes > 5)
                    return "md-accent";
                return "md-primary";
            };

            vm.getMachineTheme = function (machine) {
                var minion = lodash.minBy(machine,
                    function (minion) {
                        return minion.Timestamp;
                    });

                return vm.getTheme(minion);
            };

            vm.resetMinion = function (minion) {
                minionService.resetMinion(minion, function() {
                    notificationsService.success('Resetting minion ' + minion.ProcessName + ' on machine ' + minion.MachineName);
                });
            };

            vm.resetAllMinions = function (machineName) {
                minionService.resetAllMinions(machineName, function() {
                    notificationsService.success('Resetting all minions on machine ' + machineName);
                });
            };
        }
    }

})();

(function() {
        "use strict";

        /** @ngInject */
        function minionService(configuration, $http) {

            function resetMinion(minion, success, error) {
                var url = configuration.apiUrl + "/minion/reset";
                $http.post(url, minion).then(success, error);
            }
            function resetAllMinions(machineName, success, error) {
                var url = configuration.apiUrl + "/machine/reset/" + machineName;
                $http.post(url).then(success, error);
            }

            var service = {
                resetMinion: resetMinion,
                resetAllMinions: resetAllMinions
            };
            return service;

        }

        angular
            .module("rhipeSupportserviceportal")
            .factory("minionService", minionService);
    }
)();
(function() {
        'use strict';

        /** @ngInject */
        function backgroundJobsService(configuration, $http) {
            return {
                listJobs: listJobs,
                getJobHistory: getJobHistory
            };

          function listJobs() {
                var url = configuration.apiUrl + '/admin/background-jobs';
                return $http.get(url);
            }

            function getJobHistory(jobName) {
              var url = configuration.apiUrl + '/admin/background-jobs/' + jobName + '/history';
                return $http.get(url);
            }
        }

        angular
            .module('rhipeSupportserviceportal')
            .factory('backgroundJobsService', backgroundJobsService);
    }
)();

(function() {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, adRoles) {
        $stateProvider
            .state('backgroundJobs', {
                url: '/background-jobs',
                template: '<background-jobs></background-jobs>',
                navItem: 'backgroundJobs',
                authorization: [adRoles.Admin]
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .directive('backgroundJobs', backgroundJobs);

    /** @ngInject */
    function backgroundJobs() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/backgroundJobs/backgroundJobs.html',
            scope: {},
            controller: backgroundJobsController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function backgroundJobsController(
            backgroundJobsService,
            notificationsService,
            $mdDialog,
            $timeout,
            $scope,
            $document) {
            var vm = this;
            var isActive = false;
            var refreshTimeoutPromise;

            vm.jobs = [];
            vm.isLoading = false;

            loadBackgroundJobs();

            $scope.$on('$destroy', function() {
                isActive = false;
                if (refreshTimeoutPromise) {
                    $timeout.cancel(refreshTimeoutPromise);
                }
            });

            function loadBackgroundJobs() {
                isActive = true;
                vm.isLoading = true;
                return backgroundJobsService.listJobs().then(
                        function(result) {
                            updateJobs(result.data);
                        },
                        function() {
                            notificationsService.failure(
                                'An unexpected error occurred',
                                'Unable to load background jobs');
                        })
                    .finally(
                        function() {
                            $timeout(function () {
                                vm.isLoading = false;
                            }, 750);
                            
                            if (isActive) {
                                refreshTimeoutPromise = $timeout(loadBackgroundJobs, 5000);
                            }
                        });
            }

            function updateJobs(updatedJobs) {
                vm.jobs.forEach(
                    function(existingJob, index) {
                        var updatedJob = updatedJobs.find(
                            function(u) {
                                return u.Name === existingJob.Name;
                            });

                        if (angular.isUndefined(updatedJob)) {
                            vm.jobs.splice(index, 1);
                        }

                        angular.extend(existingJob, updatedJob);
                    }
                );

                updatedJobs.forEach(
                    function(updatedJob) {
                        var existingJob = vm.jobs.find(
                            function(j) {
                                return j.Name === updatedJob.Name;
                            });

                        if (angular.isUndefined(existingJob)) {
                            vm.jobs.push(updatedJob);
                        }
                    });
            }

            vm.showJobDetails = function(ev, job) {
                $mdDialog.show(
                    {
                        controller: 'backgroundJobDetailsController',
                        controllerAs: 'vm',
                        templateUrl: 'app/components/jobs/backgroundJobs/jobDetails/jobDetails.html',
                        parent: angular.element($document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            jobName: job.Name,
                            jobFullName: job.FullName
                        }
                    });
            };
        }
    }
})();

(function () {
    'use strict';

    angular
      .module('rhipeSupportserviceportal')
      .service('notificationsService', notificationsService);

    /** @ngInject */
    function notificationsService($rootScope, $http, lodash, toastr) {

        var service = {
            notifications: [],
            updateNotification: updateNotification,
            success: successMessage,
            failure: failureMessage,
            error: failureMessage,
            info: infoMessage
        };

        function updateNotification(notification) {
            var exisiting = lodash.find(service.notifications, function (o) { return notification.NotificationId != null && o.NotificationId === notification.NotificationId; });
            if (exisiting) {
                lodash.assign(exisiting, notification);
            } else {
                service.notifications.push(notification);
                toastr.info(notification.Title, notification.Description, {
                    extraData: notification,
                    timeOut: 5000,
                    tapToDismiss: true,
                    extendedTimeOut: 20000
                });
            }
            $rootScope.$broadcast('notification:updated', notification);
        }

        function successMessage(message, description) {
            updateNotification({
                Title: message,
                Description: description,
                Status: 'Success'
            });
        }

        function infoMessage(message, description) {
            updateNotification({
                Title: message,
                Description: description,
                Status: 'Info'
            });
        }

        function failureMessage(message, description) {
            updateNotification({
                Title: message,
                Description: description,
                Status: 'Fail'
            });
        }

        return service;
    }
})();

(function () {
  'use strict';

  angular.module('rhipeSupportserviceportal')
    .service('authContextService', authContextService);

  function authContextService(lodash, $http, $q, $window) {
    var cachedClaims = null;

    function getUserClaims(useCache) {
      var deferred = $q.defer();

      if (useCache && cachedClaims) {
        deferred.resolve(cachedClaims);
      } else {
        $http.get('/bff/user?slide=false')
          .then(function (response) {
            cachedClaims = response.data;
            deferred.resolve(cachedClaims);
          },
          function () {
            deferred.resolve(null);
          });
      }

      return deferred.promise;
    }

    this.checkAuthenticated = function () {
      return getUserClaims(true)
        .then(function (claims) {
          return (claims !== null && claims.length > 0);
        });
    }

    function login(returnPath) {
      var url = '/bff/login';
      if (returnPath) {
        url += '?returnUrl=' + returnPath;
      }
      $window.location.href = url;
    }

    this.logOut = function () {
      getUserClaims(false)
        .then(function (claims) {
          var claim = null;
          if (claims) {
            claim = claims.find(function (value) {
              return value.type === 'bff:logout_url';
            });
          }

          if (claim) {
            $window.location.href = claim.value;
          } else {
            $window.location.href = '/';
          }
        });
    };

    this.authorizeRoute = function (event, toState) {
      return getUserClaims(true)
        .then(function (claims) {
          if (!claims) {
            login();
            event.preventDefault();
            return;
          }

          if (toState.authorization.length) {
            var roles = claims.filter(function (value) {
              return value.type === "roles";
            }).map(function (value) {
              return value.value;
            });

            var matchingRoles = lodash.intersection(toState.authorization, roles);
            if (matchingRoles.length == 0) {
              event.preventDefault();
            }
          }
        });
    };
  }
})();

(function () {
    'use strict';

    angular
      .module('rhipeSupportserviceportal')
      .provider('authProvider', authProvider);


        /** @ngInject */
    function authProvider($httpProvider) {
        $httpProvider.defaults.useXDomain = true;
        $httpProvider.defaults.headers.common['x-csrf'] = 1;
        $httpProvider.defaults.headers.common["Accept"] = "application/json";
        $httpProvider.defaults.headers.common["Content-Type"] = "application/json";
        this.$get = function () {
            return {};
        };
    }

})();

/* eslint-disable angular/typecheck-object, no-undef, angular/typecheck-function, no-unused-vars, no-empty */
(function webpackUniversalModuleDefinition(root, factory) {
    if (typeof exports === 'object' && typeof module === 'object')
        module.exports = factory(require("angular"), require("angular-material"));
    else if (typeof define === 'function' && define.amd)
        define(["angular", "angular-material"], factory);
    else if (typeof exports === 'object')
        exports["mdCollectionPagination"] = factory(require("angular"), require("angular-material"));
    else
        root["mdCollectionPagination"] = factory(root["angular"], root["angular-material"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
    return /******/ (function (modules) { // webpackBootstrap
        /******/ 	// The module cache
        /******/ 	var installedModules = {};

        /******/ 	// The require function
        /******/ 	function __webpack_require__(moduleId) {

            /******/ 		// Check if module is in cache
            /******/ 		if (installedModules[moduleId])
                /******/ 			return installedModules[moduleId].exports;

            /******/ 		// Create a new module (and put it into the cache)
            /******/ 		var module = installedModules[moduleId] = {
                /******/ 			i: moduleId,
                /******/ 			l: false,
                /******/ 			exports: {}
                /******/
            };

            /******/ 		// Execute the module function
            /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

            /******/ 		// Flag the module as loaded
            /******/ 		module.l = true;

            /******/ 		// Return the exports of the module
            /******/ 		return module.exports;
            /******/
        }


        /******/ 	// expose the modules object (__webpack_modules__)
        /******/ 	__webpack_require__.m = modules;

        /******/ 	// expose the module cache
        /******/ 	__webpack_require__.c = installedModules;

        /******/ 	// identity function for calling harmony imports with the correct context
        /******/ 	__webpack_require__.i = function (value) { return value; };

        /******/ 	// define getter function for harmony exports
        /******/ 	__webpack_require__.d = function (exports, name, getter) {
            /******/ 		if (!__webpack_require__.o(exports, name)) {
                /******/ 			Object.defineProperty(exports, name, {
                    /******/ 				configurable: false,
                    /******/ 				enumerable: true,
                    /******/ 				get: getter
                    /******/
                });
                /******/
            }
            /******/
        };

        /******/ 	// getDefaultExport function for compatibility with non-harmony modules
        /******/ 	__webpack_require__.n = function (module) {
            /******/ 		var getter = module && module.__esModule ?
            /******/ 			function getDefault() { return module['default']; } :
            /******/ 			function getModuleExports() { return module; };
            /******/ 		__webpack_require__.d(getter, 'a', getter);
            /******/ 		return getter;
            /******/
        };

        /******/ 	// Object.prototype.hasOwnProperty.call
        /******/ 	__webpack_require__.o = function (object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

        /******/ 	// __webpack_public_path__
        /******/ 	__webpack_require__.p = "";

        /******/ 	// Load entry module and return exports
        /******/ 	return __webpack_require__(__webpack_require__.s = 5);
        /******/
    })
    /************************************************************************/
    /******/([
    /* 0 */
    /***/ (function (module, exports, __webpack_require__) {

        "use strict";


        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _template = __webpack_require__(4);

        var _template2 = _interopRequireDefault(_template);

        var _controller = __webpack_require__(3);

        var _controller2 = _interopRequireDefault(_controller);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        exports.default = {
            template: _template2.default,
            controller: _controller2.default,
            controllerAs: 'vm',
            bindings: {
                collection: '<',
                paginatedCollection: '=',
                perPage: '<',
                navigationLength: '<'
            }
        };

        /***/
    }),
    /* 1 */
    /***/ (function (module, exports) {

        module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

        /***/
    }),
    /* 2 */
    /***/ (function (module, exports) {

        module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

        /***/
    }),
    /* 3 */
    /***/ (function (module, exports, __webpack_require__) {

        "use strict";


        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

        function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        var CollectionPaginationController = function () {
            function CollectionPaginationController() {
                _classCallCheck(this, CollectionPaginationController);
            }

            _createClass(CollectionPaginationController, [{
                key: "$onChanges",
                value: function $onChanges() {
                    this.perPage = this.perPage || 5;
                    this.shownIndexesCount = this.navigationLength || 5;
                    this.lastIndex = Math.ceil(this.collection.length / this.perPage) - 1;
                    this.allIndexes = [];
                    for (var i = 0; i <= this.lastIndex; this.allIndexes.push(i++)) { }
                    this.beginning();
                }
            }, {
                key: "beginning",
                value: function beginning() {
                    this.selectedIndex = 0;
                    this.indexesOffset = 0;
                    this.update();
                }
            }, {
                key: "end",
                value: function end() {
                    this.selectedIndex = this.lastIndex;
                    while (this.indexesOffset + this.shownIndexesCount <= this.lastIndex) {
                        this.indexesOffset += this.shownIndexesCount;
                    } this.update();
                }
            }, {
                key: "select",
                value: function select(index) {
                    this.selectedIndex = index;
                    this.update();
                }
            }, {
                key: "previousIndexes",
                value: function previousIndexes() {
                    this.selectedIndex = this.indexesOffset - 1;
                    this.indexesOffset -= this.shownIndexesCount;
                    this.update();
                }
            }, {
                key: "nextIndexes",
                value: function nextIndexes() {
                    this.indexesOffset += this.shownIndexesCount;
                    this.selectedIndex = this.indexesOffset;
                    this.update();
                }
            }, {
                key: "update",
                value: function update() {
                    var offset = this.selectedIndex * this.perPage;
                    this.paginatedCollection = this.collection.slice(offset, offset + this.perPage);
                }
            }]);

            return CollectionPaginationController;
        }();

        exports.default = CollectionPaginationController;

        /***/
    }),
    /* 4 */
    /***/ (function (module, exports) {

        module.exports = "<section layout=\"row\" layout-align=\"center center\" layout-wrap ng-show=\"vm.allIndexes.length > 1\">\n  <md-button class=\"md-icon-button md-raised md-primary\" ng-click=\"vm.beginning()\">\n    <<\n  </md-button>\n  <md-button class=\"md-icon-button md-raised\" ng-click=\"vm.previousIndexes()\" ng-hide=\"vm.indexesOffset === 0\">\n    ...\n  </md-button>\n  <md-button class=\"md-icon-button md-raised\" ng-class=\"{ 'md-accent': index === vm.selectedIndex }\"\n             ng-click=\"vm.select(index)\" ng-repeat=\"index in vm.allIndexes | limitTo : vm.shownIndexesCount : vm.indexesOffset\">\n    {{ index + 1 }}\n  </md-button>\n  <md-button class=\"md-icon-button md-raised\" ng-click=\"vm.nextIndexes()\"\n             ng-show=\"vm.indexesOffset + vm.shownIndexesCount <= vm.lastIndex\">\n    ...\n  </md-button>\n  <md-button class=\"md-icon-button md-raised md-primary\" ng-click=\"vm.end()\">\n    >>\n  </md-button>\n</section>\n";

        /***/
    }),
    /* 5 */
    /***/ (function (module, exports, __webpack_require__) {

        "use strict";


        Object.defineProperty(exports, "__esModule", {
            value: true
        });

        var _angular = __webpack_require__(1);

        var _angular2 = _interopRequireDefault(_angular);

        __webpack_require__(2);

        var _component = __webpack_require__(0);

        var _component2 = _interopRequireDefault(_component);

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        exports.default = _angular2.default.module('mdCollectionPagination', ['ng', 'ngMaterial']).component('mdCollectionPagination', _component2.default).name;

        /***/
    })
    /******/]);
});
(function() {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .factory('hubLogger', hubLogger);

    /** @ngInject */
    function hubLogger($, $log) {
        var getStateName = function (stateCode) {
            switch (stateCode) {
                case $.signalR.connectionState.connecting:
                    return "connecting";
                case $.signalR.connectionState.connected:
                    return "connected";
                case $.signalR.connectionState.reconnecting:
                    return "reconnecting";
                case $.signalR.connectionState.disconnected:
                    return "disconnected";
                default:
                    return "unknown";
            }
        };

        var isConnected = function (stateCode) {
            return stateCode === $.signalR.connectionState.connected;
        };

        var logAction = function (hubName, action) {
            $log.debug(hubName + " " + action);
        };

        var logFailure = function (hubName, action, error) {
            $log.warn(hubName + " " + action + ": " + error);
        };

        var logStateChanged = function (hubName, state) {
            $log.debug(hubName + " state changed: " + getStateName(state.oldState) + " -> " + getStateName(state.newState));
        };

        return {
            getStateName: getStateName,
            isConnected: isConnected,
            logAction: logAction,
            logFailure: logFailure,
            logStateChanged: logStateChanged
        };
    }
})();

(function () {
    'use strict';

    angular
      .module('rhipeSupportserviceportal')
      .config(config);

    /** @ngInject */
    function config(toastrConfig) {
        toastrConfig.allowHtml = true;
        toastrConfig.timeOut = 3000;
        toastrConfig.positionClass = 'toast-top-right';
        toastrConfig.preventDuplicates = false;
        toastrConfig.progressBar = true;
    }

})();

(function () {
    'use strict';

    angular
      .module('rhipeSupportserviceportal')
      .config(config);

    /** @ngInject */
    function config($logProvider, $locationProvider, $mdThemingProvider) {
        $locationProvider.html5Mode(true).hashPrefix("!");
        // Enable log
        $logProvider.debugEnabled(true);

        $mdThemingProvider.theme('default')
            .primaryPalette('blue')
            .accentPalette('orange');

        $mdThemingProvider.theme('error').backgroundPalette('red');
        $mdThemingProvider.theme('warning').backgroundPalette('orange');
        $mdThemingProvider.theme('notification').backgroundPalette('blue');
    }

})();

(function () {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .constant('configuration', buildConfiguration());

    /** @ngInject */
    function buildConfiguration() {
        var service = {
            apiUrl: '/api',
            signalrUri: '/signalr/hubs'
        };
        return service;
    }
})();

(function() {
  'use strict';

  angular
    .module('rhipeSupportserviceportal')
    .constant('Nav', {
        current: ''
      });

})();

(function() {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .run(runBlock);

    function runBlock($rootScope, Nav, authContextService, notificationsService, bsLoadingOverlayService, minionRepository) {
        minionRepository.init();

        var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            if (toState.navItem)
                Nav.current = toState.navItem;
        });

        var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
            if (toState.authorization.length) {
                authContextService.authorizeRoute(event, toState, toParams);
            }
        });

      bsLoadingOverlayService.setGlobalConfig({
          delay: 0,
          templateUrl: 'app/components/overlay/loading.html'
      });

      $rootScope.$on('$destroy', stateChangeSuccess);
      $rootScope.$on('$destroy', stateChangeStart);
    }

})();

(function () {
    'use strict';

    angular
        .module('rhipeSupportserviceportal')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider, adRoles) {
        $stateProvider
            .state("home", {
                url: "/",
                template: "<minions></minions>",
                navItem: 'minions',
                authorization: [adRoles.Admin]
            });


        $urlRouterProvider.otherwise('/');
    }
})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('rhipeSupportserviceportal')
    .constant('moment', moment)
    .constant('dateFormat', 'DD MMM YYYY')
    .constant('portalVersion', '1.0.0-local')
    .constant('environment', 'Local Development')
    .constant('adRoles',
      {
          Admin: 'Admin',
          User: 'User'
      });
})();

angular.module("rhipeSupportserviceportal").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/backgroundJobs/backgroundJobs.html","<md-content class=md-padding><p style=text-align:center ng-if=\"!vm.isLoading && !vm.jobs.length\">No background jobs available.</p><div style=\"width:50px; margin:0 auto\" ng-if=\"vm.isLoading && !vm.jobs.length\"><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div class=md-whiteframe-4dp><md-list style=\"padding: 0\"><div ng-repeat=\"job in vm.jobs\"><md-list-item ng-click=\"vm.showJobDetails ($event, job)\" class=md-2-line><div class=md-list-item-text layout=row><md-progress-circular style=\"margin-right: 10px; align-self: center\" md-mode=indeterminate md-diameter=24 ng-if=\"job.LastRunResult  === \'In Progress\'\"></md-progress-circular><md-icon ng-if=\"job.LastRunResult && job.LastRunResult !== \'In Progress\'\" ng-class=\"{\'md-warn\': job.LastRunResult  !== \'Complete\' }\" style=\"align-self: center; margin: 0 10px 0 0\">{{job.LastRunResult === \'Complete\' ? \'done\' : \'error\'}}</md-icon><md-icon ng-if=!job.LastRunResult style=\"align-self: center; margin: 0 10px 0 0\"></md-icon><div style=\"align-self: center; flex: 1\"><div style=\"line-height: 18px\"><span ng-bind=job.Name></span></div><div style=\"line-height: 16px\"><small ng-bind=job.Application></small></div></div><p flex=20 style=\"align-self: center; margin: 0 20px; overflow: hidden; text-overflow: ellipsis\"><span ng-if=job.LastRunMessage>Last run <strong ng-bind=job.LastRunMessage></strong></span></p><p flex=20 style=\"align-self: center; margin: 0 20px\">Last ran <strong ng-if=job.LastRunCompletedAt am-time-ago=job.LastRunCompletedAt title={{job.LastRunCompletedAt}}></strong> <strong ng-if=!job.LastRunCompletedAt>Never</strong></p><p flex=20 style=\"align-self: center; margin: 0 20px\"><span>Total runs <strong ng-bind=\"job.TotalRuns || 0\"></strong></span></p></div></md-list-item><md-divider ng-if=!$last></md-divider></div></md-list></div></md-content>");
$templateCache.put("app/components/minions/minions.html","<md-content class=md-padding ng-repeat=\"(key, machine) in vm.machines track by key\"><md-expansion-panel><md-expansion-panel-collapsed style=\"padding: 0\"><md-toolbar class=md-theme-light ng-class=vm.getMachineTheme(machine)><h2 class=md-toolbar-tools><span>{{key}} ({{machine.length}})</span></h2></md-toolbar></md-expansion-panel-collapsed><md-expansion-panel-expanded><md-toolbar layout=row layout-align=\"space-between center\" class=md-theme-light ng-class=vm.getMachineTheme(machine) ng-click=$panel.collapse()><h2 class=md-toolbar-tools><span>{{key}} ({{machine.length}})</span></h2></md-toolbar><md-expansion-panel-content><md-grid-list md-cols-sm=1 md-cols-md=2 md-cols-lg=3 md-cols-gt-lg=4 md-gutter=0px md-row-height=330px><md-grid-tile ng-repeat=\"minion in machine track by minion.Id\"><md-card style=\"width: 500px\" md-ink-ripple><md-toolbar ng-class=vm.getTheme(minion)><h2 class=md-toolbar-tools><span>{{minion.ProcessName}}</span></h2></md-toolbar><table md-table><tbody md-body><tr md-row><td md-cell>Version</td><td md-cell>{{minion.Version}}</td></tr><tr md-row><td md-cell>Last Seen</td><td md-cell><span am-time-ago=minion.Timestamp></span></td></tr><tr md-row><td md-cell>Process Id</td><td md-cell>{{minion.ProcessId}}</td></tr><tr md-row><td md-cell>Used Memory</td><td md-cell>{{minion.UsedMemory}} MB</td></tr></tbody></table><md-divider></md-divider><div layout=row layout-align=\"end center\"><md-button class=md-primary ng-click=vm.resetMinion(minion)>Restart Minion</md-button></div></md-card></md-grid-tile></md-grid-list></md-expansion-panel-content><md-expansion-panel-footer><div flex></div><md-button class=md-warn ng-click=vm.resetAllMinions(key)>Restart Minions</md-button><md-button ng-click=$panel.collapse()>Collapse</md-button></md-expansion-panel-footer></md-expansion-panel-expanded></md-expansion-panel></md-content>");
$templateCache.put("app/components/navbar/navbar.html","<md-toolbar layout=row layout-align=\"space-between center\"><md-nav-bar md-selected-nav-item=vm.currentNavItem nav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-href=/minions name=minions>Minions</md-nav-item><md-nav-item md-nav-href=/scheduled-jobs name=scheduledJobs>Scheduled Jobs</md-nav-item><md-nav-item md-nav-href=/background-jobs name=backgroundJobs>Background Jobs</md-nav-item></md-nav-bar><div><md-button ng-click=vm.logOut()>Log Out</md-button><md-button>{{ vm.version }}</md-button></div></md-toolbar>");
$templateCache.put("app/components/overlay/loading.html","<div style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0; background-color: rgba(255,255,255,0.7)\"><div id=floatingCirclesG><div class=f_circleG id=frotateG_01></div><div class=f_circleG id=frotateG_02></div><div class=f_circleG id=frotateG_03></div><div class=f_circleG id=frotateG_04></div><div class=f_circleG id=frotateG_05></div><div class=f_circleG id=frotateG_06></div><div class=f_circleG id=frotateG_07></div><div class=f_circleG id=frotateG_08></div></div><style>#floatingCirclesG {\r\n      position: absolute;\r\n      top: 0;\r\n      bottom: 0;\r\n      left: 0;\r\n      right: 0;\r\n      width: 51px;\r\n      height: 51px;\r\n      margin: auto;\r\n      transform: scale(0.6);\r\n      -o-transform: scale(0.6);\r\n      -ms-transform: scale(0.6);\r\n      -webkit-transform: scale(0.6);\r\n      -moz-transform: scale(0.6);\r\n    }\r\n\r\n    .f_circleG {\r\n      position: absolute;\r\n      background-color: rgb(255, 255, 255);\r\n      height: 9px;\r\n      width: 9px;\r\n      border-radius: 5px;\r\n      -o-border-radius: 5px;\r\n      -ms-border-radius: 5px;\r\n      -webkit-border-radius: 5px;\r\n      -moz-border-radius: 5px;\r\n      animation-name: f_fadeG;\r\n      -o-animation-name: f_fadeG;\r\n      -ms-animation-name: f_fadeG;\r\n      -webkit-animation-name: f_fadeG;\r\n      -moz-animation-name: f_fadeG;\r\n      animation-duration: 0.622s;\r\n      -o-animation-duration: 0.622s;\r\n      -ms-animation-duration: 0.622s;\r\n      -webkit-animation-duration: 0.622s;\r\n      -moz-animation-duration: 0.622s;\r\n      animation-iteration-count: infinite;\r\n      -o-animation-iteration-count: infinite;\r\n      -ms-animation-iteration-count: infinite;\r\n      -webkit-animation-iteration-count: infinite;\r\n      -moz-animation-iteration-count: infinite;\r\n      animation-direction: normal;\r\n      -o-animation-direction: normal;\r\n      -ms-animation-direction: normal;\r\n      -webkit-animation-direction: normal;\r\n      -moz-animation-direction: normal;\r\n    }\r\n\r\n    #frotateG_01 {\r\n      left: 0;\r\n      top: 21px;\r\n      animation-delay: 0.2295s;\r\n      -o-animation-delay: 0.2295s;\r\n      -ms-animation-delay: 0.2295s;\r\n      -webkit-animation-delay: 0.2295s;\r\n      -moz-animation-delay: 0.2295s;\r\n    }\r\n\r\n    #frotateG_02 {\r\n      left: 6px;\r\n      top: 6px;\r\n      animation-delay: 0.316s;\r\n      -o-animation-delay: 0.316s;\r\n      -ms-animation-delay: 0.316s;\r\n      -webkit-animation-delay: 0.316s;\r\n      -moz-animation-delay: 0.316s;\r\n    }\r\n\r\n    #frotateG_03 {\r\n      left: 21px;\r\n      top: 0;\r\n      animation-delay: 0.3925s;\r\n      -o-animation-delay: 0.3925s;\r\n      -ms-animation-delay: 0.3925s;\r\n      -webkit-animation-delay: 0.3925s;\r\n      -moz-animation-delay: 0.3925s;\r\n    }\r\n\r\n    #frotateG_04 {\r\n      right: 6px;\r\n      top: 6px;\r\n      animation-delay: 0.469s;\r\n      -o-animation-delay: 0.469s;\r\n      -ms-animation-delay: 0.469s;\r\n      -webkit-animation-delay: 0.469s;\r\n      -moz-animation-delay: 0.469s;\r\n    }\r\n\r\n    #frotateG_05 {\r\n      right: 0;\r\n      top: 21px;\r\n      animation-delay: 0.5455s;\r\n      -o-animation-delay: 0.5455s;\r\n      -ms-animation-delay: 0.5455s;\r\n      -webkit-animation-delay: 0.5455s;\r\n      -moz-animation-delay: 0.5455s;\r\n    }\r\n\r\n    #frotateG_06 {\r\n      right: 6px;\r\n      bottom: 6px;\r\n      animation-delay: 0.622s;\r\n      -o-animation-delay: 0.622s;\r\n      -ms-animation-delay: 0.622s;\r\n      -webkit-animation-delay: 0.622s;\r\n      -moz-animation-delay: 0.622s;\r\n    }\r\n\r\n    #frotateG_07 {\r\n      left: 21px;\r\n      bottom: 0;\r\n      animation-delay: 0.6985s;\r\n      -o-animation-delay: 0.6985s;\r\n      -ms-animation-delay: 0.6985s;\r\n      -webkit-animation-delay: 0.6985s;\r\n      -moz-animation-delay: 0.6985s;\r\n    }\r\n\r\n    #frotateG_08 {\r\n      left: 6px;\r\n      bottom: 6px;\r\n      animation-delay: 0.775s;\r\n      -o-animation-delay: 0.775s;\r\n      -ms-animation-delay: 0.775s;\r\n      -webkit-animation-delay: 0.775s;\r\n      -moz-animation-delay: 0.775s;\r\n    }\r\n\r\n    <a href=\'https://github.com/keyframes\' class=\'user-mention\'>@keyframes</a> f_fadeG {\r\n    0% {\r\n      background-color: rgb(0, 0, 0);\r\n    }\r\n    100% {\r\n      background-color: rgb(255, 255, 255);\r\n    }\r\n    }\r\n\r\n    @-o-keyframes f_fadeG {\r\n      0% {\r\n        background-color: rgb(0, 0, 0);\r\n      }\r\n      100% {\r\n        background-color: rgb(255, 255, 255);\r\n      }\r\n    }\r\n\r\n    @-ms-keyframes f_fadeG {\r\n      0% {\r\n        background-color: rgb(0, 0, 0);\r\n      }\r\n      100% {\r\n        background-color: rgb(255, 255, 255);\r\n      }\r\n    }\r\n\r\n    @-webkit-keyframes f_fadeG {\r\n      0% {\r\n        background-color: rgb(0, 0, 0);\r\n      }\r\n      100% {\r\n        background-color: rgb(255, 255, 255);\r\n      }\r\n    }\r\n\r\n    @-moz-keyframes f_fadeG {\r\n      0% {\r\n        background-color: rgb(0, 0, 0);\r\n      }\r\n      100% {\r\n        background-color: rgb(255, 255, 255);\r\n      }\r\n    }</style></div>");
$templateCache.put("app/components/scheduledJobs/scheduledJobs.html","<md-content class=md-padding><div layout=row layout-align=\"end center\"><small ng-if=vm.lastRefreshed>Last refreshed <span am-time-ago=vm.lastRefreshed title={{vm.lastRefreshed}}></span></small><md-button class=\"md-raised md-primary\" ng-click=vm.refresh() ng-disabled=vm.isLoading>{{vm.isLoading ? \'Refreshing...\' : \'Refresh\'}}</md-button></div><p style=text-align:center ng-if=\"!vm.isLoading && !vm.jobs.length\">No scheduled jobs available.</p><div style=\"width:50px; margin:0 auto\" ng-if=\"vm.isLoading && !vm.jobs.length\"><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div class=md-whiteframe-4dp><md-list style=\"padding: 0\"><div ng-repeat=\"job in vm.jobs\"><md-list-item ng-click=\"vm.showJobDetails ($event, job)\" class=md-2-line><div class=md-list-item-text layout=row style=\"align-items: center\"><md-progress-circular style=\"margin-right: 10px; align-self: center\" md-mode=indeterminate md-diameter=24 ng-if=\"job.LastRunResult  === \'In Progress\'\"></md-progress-circular><md-icon ng-if=\"job.LastRunResult && job.LastRunResult !== \'In Progress\'\" ng-class=\"{\'md-warn\': job.LastRunResult  !== \'Complete\' }\" style=\"align-self: center; margin: 0 10px 0 0\">{{job.LastRunResult === \'Complete\' ? \'done\' : \'error\'}}</md-icon><md-icon ng-if=!job.LastRunResult style=\"align-self: center; margin: 0 10px 0 0\"></md-icon><div style=\"align-self: center; flex: 1\"><div style=\"line-height: 18px\"><span ng-bind=job.DisplayName></span></div><div style=\"line-height: 16px\"><small ng-bind=job.Application></small></div></div><p flex=20 style=\"align-self: center; margin: 0 20px\"><span ng-if=job.LastRunMessage>Last run <strong ng-bind=job.LastRunMessage></strong></span></p><p flex=20 style=\"align-self: center; margin: 0 20px\">Last ran <strong ng-if=job.LastRunCompletedAt am-time-ago=job.LastRunCompletedAt title={{job.LastRunCompletedAt}}></strong> <strong ng-if=!job.LastRunCompletedAt>Never</strong></p><p flex=20 style=\"align-self: center; margin: 0 20px\"><span ng-if=!job.IsDisabled>Next run <strong am-time-ago=job.NextRunTime title={{job.NextRun}}></strong></span> <span ng-if=job.IsDisabled>Disabled</span></p><md-button class=\"md-raised md-primary\" style=\"min-width: 150px; height: 36px\" ng-click=vm.enableAndRunJob(job) ng-if=job.IsDisabled ng-disabled=vm.triggeringJob>Enable and Run</md-button><md-button class=\"md-raised md-primary\" style=\"min-width: 150px; height: 36px\" ng-click=vm.runJob(job) ng-if=!job.IsDisabled ng-disabled=\"vm.triggeringJob || job.LastRunResult === \'In Progress\'\">Run Now</md-button></div></md-list-item><md-divider ng-if=!$last></md-divider></div></md-list></div></md-content>");
$templateCache.put("app/components/session/sessionExpired.html","<div class=bs-loading-container bs-loading-overlay><md-toolbar class=md-warn><div class=md-toolbar-tools><h2 class=md-flex>Your session has expired, please log back in and try again.</h2></div></md-toolbar></div>");
$templateCache.put("app/components/backgroundJobs/jobDetails/jobDetails.html","<md-dialog aria-label=\"Job Details\" style=\"width: 1000px\"><md-toolbar><div class=md-toolbar-tools><h2 ng-bind=vm.jobName></h2><span flex></span><md-button class=md-icon-button ng-click=vm.close()><md-icon md-svg-src=img/icons/ic_close_24px.svg aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-subheader class=md-primary>Job History</md-subheader><div class=md-padding><span ng-if=\"vm.isLoadingJobHistory && !vm.jobHistory.length\"><md-progress-circular md-mode=indeterminate></md-progress-circular>Loading job history... </span><span ng-show=\"!vm.isLoadingJobHistory && !vm.jobHistory.length\">No job history found</span><div class=md-whiteframe-4dp><md-list style=\"padding: 0\"><div ng-repeat=\"record in vm.jobHistory\"><md-list-item class=md-list-item-text><div style=\"display: flex; flex-direction: column; width: 100%\"><div style=\"display: flex; align-items: center; cursor: pointer; outline: none; padding: 10px 0\" ng-click=\"record.IsExpanded = !record.IsExpanded\" md-ink-ripple=true><md-progress-circular style=\"margin-right: 10px\" md-mode=indeterminate md-diameter=24 ng-if=\"record.Result === \'In Progress\'\"></md-progress-circular><md-icon ng-if=\"record.Result !== \'In Progress\'\" ng-class=\"{\'md-warn\': record.Result !== \'Complete\' }\" style=\"align-self: center; margin: 0 10px 0 0\">{{record.Result === \'Complete\' ? \'done\' : \'error\'}}</md-icon><div style=\"align-self: center; margin: 0 20px; flex: 1.3\"><div style=\"line-height: 18px\"><span ng-bind=record.Message></span></div><div style=\"line-height: 16px; white-space: nowrap\"><small ng-bind=record.JobId></small></div></div><p style=\"align-self: center; margin: 0 20px; flex: 1\">Started <strong am-time-ago=record.StartedAt title={{record.StartedAt}}></strong></p><p style=\"align-self: center; margin: 0 20px; flex: 1.1\"><span ng-if=record.CompletedAt>Completed <strong am-time-ago=record.CompletedAt title={{record.CompletedAt}}></strong> (<span ng-bind=record.Duration></span>)</span></p></div><div ng-show=record.IsExpanded style=\"padding-bottom: 16px\"><div class=md-whiteframe-4dp><md-subheader class=md-primary>Job Parameters</md-subheader><div style=\"padding: 0 10px 5px 10px\"><pre style=\"overflow: hidden; text-overflow: ellipsis\" ng-attr-title={{vm.format(record.Job)}}>{{vm.format(record.Job)}}</pre></div></div></div></div></md-list-item><md-divider ng-if=!$last></md-divider></div></md-list></div></div></md-dialog-content></md-dialog>,");
$templateCache.put("app/components/scheduledJobs/jobDetails/jobDetails.html","<md-dialog aria-label=\"Job Details\" style=\"width: 1000px\"><md-toolbar><div class=md-toolbar-tools><h2 ng-bind=vm.jobName></h2><span flex></span><md-button class=md-icon-button ng-click=vm.close()><md-icon md-svg-src=img/icons/ic_close_24px.svg aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-subheader class=md-primary>Job History</md-subheader><div class=md-padding><span ng-if=\"vm.isLoadingJobHistory && !vm.jobHistory\"><md-progress-circular md-mode=indeterminate></md-progress-circular>Loading job history... </span><span ng-show=\"!vm.isLoadingJobHistory && !vm.jobHistory.length\">No job history found</span><div class=md-whiteframe-4dp><md-list style=\"padding: 0\"><div ng-repeat=\"record in vm.jobHistory\"><md-list-item class=md-list-item-text><md-progress-circular style=\"margin-right: 10px\" md-mode=indeterminate md-diameter=24 ng-if=\"record.Result === \'In Progress\'\"></md-progress-circular><md-icon ng-if=\"record.Result !== \'In Progress\'\" ng-class=\"{\'md-warn\': record.Result !== \'Complete\' }\" style=\"align-self: center; margin: 0 10px 0 0\">{{record.Result === \'Complete\' ? \'done\' : \'error\'}}</md-icon><p ng-bind=record.Message style=\"align-self: center; margin: 0 20px; flex: 1\"></p><p style=\"align-self: center; margin: 0 20px; flex: 1\">Started <strong am-time-ago=record.StartedAt title={{record.StartedAt}}></strong></p><p style=\"align-self: center; margin: 0 20px; flex: 1.1\"><span ng-if=record.CompletedAt>Completed <strong am-time-ago=record.CompletedAt title={{record.CompletedAt}}></strong> (<span ng-bind=record.Duration></span>)</span></p></md-list-item><md-divider ng-if=!$last></md-divider></div></md-list></div></div></md-dialog-content></md-dialog>,");}]);